module.exports = __webpack_public_path__ + "static/media/ic-mic.c4ca6dc7.png";